import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { AuthenticationService } from '@alfresco/adf-core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, Input, OnInit } from '@angular/core';
import { ClienteModel } from 'app/model/cliente/cliente.model';
import { ClienteService } from 'app/service/cliente/cliente.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-listaclientes',
  templateUrl: './listaclientes.component.html',
  styleUrls: ['./listaclientes.component.scss']
})
export class ListaclientesComponent implements OnInit {

  public page: ResponsePageable;
  public spinner = false;
  public idEmpresa: any;

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  public user: any;
  public superUser = false;
  public createEmpresa = false;
  public editEmpresa = false;
  public deleteEmpresa = false;
  public viewEmpresa = false;
  public arrayString: string;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private clienteService: ClienteService) {

    }

  ngOnInit() {
    this.listarClientesUsuario();
    this.getAuthority();
  }

  getIdEmpresa(id: number) {
    this.idEmpresa = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(id), 'pcdoc').toString());
    this.router.navigate(['/cliente', this.idEmpresa]);
  }

  toNovoCliente() {
    this.router.navigate(['/adicionar-cliente']);
  }

  listarClientesUsuario() {
    this.clienteService.getPageClientesUsuario().subscribe(data => {
      this.clientes = data.content;
      this.spinner = true;
    }, err => {
      console.error(err);
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
      if (this.arrayString.includes('LIST_EMPRESA')) {
        this.viewEmpresa = true;
      }
      if (this.arrayString.includes('DELETE_EMPRESA')) {
        this.deleteEmpresa = true;
      }
      if (this.arrayString.includes('EDIT_EMPRESA')) {
        this.editEmpresa = true;
      }
      if (this.arrayString.includes('ADD_EMPRESA')) {
        this.createEmpresa = true;
      }
      if (this.arrayString.includes('SUPER_USER')) {
        this.superUser = true;
      }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
        try {
            const bytes = CryptoJS.AES.decrypt(store, sessionStorage.getItem('ticket-ECM'));
            this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            return this.arrayString;
        } catch (e) {
            sessionStorage.clear();
        }
    }

    return null;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/listaclientes/listaclientes.component.ts